import styled from 'styled-components';

export const ControlsSection = styled.div<{ white?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: ${(p) => (p.white ? '#FFF' : '#fbfbfb')};
  border-bottom: solid 1px #e5e5e5;
`;
